module.exports = __webpack_public_path__ + "static/media/hand-3d.ff408df0.png";